import { render, staticRenderFns } from "./NoticeInput.vue?vue&type=template&id=5bca8ea8&"
import script from "./NoticeInput.vue?vue&type=script&lang=js&"
export * from "./NoticeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports